export default {
    data() {
        return {
            info: {},
            topicList: [],
            p: 1,
            count: 0
        }
    },

    created() {
        this.getTopicList();
        this.getInfo();
    },

    methods: {
        // 获取话题列表
        getTopicList() {
            const loading = this.$loading({
                text: '加载中...'
            })
            this.$post('api.php/Home/topicList',{
                p: this.p
            }).then(res => {
                if (res.status == 1) {
                    this.topicList = res.data.list || [];
                    this.count = res.data.count || 0;
                }
            }).finally(() => {
                loading.close();
            })
        },

        changePage(e) {
            this.p = e;
            this.getTopicList();
        },

        // 获取右侧列表
        getInfo() {
            this.$post('api.php/Home/topicRight').then(res => {
                if(res.status == 1) {
                    this.info = res.data || {};
                }
            })
        }
    }
}
